// import { RichTextElement } from '@kontent-ai/react-components';
import React from 'react';
import RichTextComponents from './RichTextComponents';
import CustomModal from './CustomModal';
import DOMPurify from 'dompurify';
// import e from 'express';
// import { useIntl } from 'react-intl';

const DigitalAssetImage: React.FC<{ element: any }> = ({ element }) => {
  //   const { formatMessage } = useIntl();

  const [show, setShow] = React.useState(false);
  const handleClose = (): void => setShow(false);

  // Utility function to check if rich text contains meaningful content
  const hasMeaningfulText = (richText: any): boolean => {
    if (!richText?.value) return false; // Check if value exists
    const strippedText = DOMPurify.sanitize(richText.value, {
      ALLOWED_TAGS: [],
      ALLOWED_ATTR: [],
    }).trim(); // Remove all HTML tags and trim whitespace
    return strippedText.length > 0; // Return true if content has any non-empty text
  };

  return (
    <>
      {/* Render the modal conditionally */}
      {show && (
        <CustomModal show={true} onHide={handleClose} element={element} />
      )}
      <div>
        {element.title.value && (
          <div className="da-title">{element.title.value}</div>
        )}
        {element.image_asset.value.length > 0 && (
          <>
            <div className="hidden-xs hidden-sm">
              <img
                src={element.image_asset.value[0].url}
                data-target="#modal-N100DF"
                data-toggle="modal"
                alt={element.image_asset.value[0].description}
                className="img-responsive center-block"
                onClick={(): void => setShow(true)}
              />
            </div>
            <div className="visible-xs-block visible-sm-block">
              <img
                src={element.image_asset.value[0].url}
                alt={element.image_asset.value[0].description}
                className="img-responsive center-block"
                onClick={(): void => setShow(true)}
              />
            </div>
          </>
        )}
        {hasMeaningfulText(element.paragraph) && (
          <div>
            <RichTextComponents element={element.paragraph} />
          </div>
        )}
        <div
          className="da-footer"
          style={{ marginTop: '0', paddingLeft: '0px' }}
        >
          <span
            className="daid"
            style={{
              textAlign: 'left',
            }}
          >
            {hasMeaningfulText(element.image_permission_language) &&
              DOMPurify.sanitize(element.image_permission_language?.value, {
                ALLOWED_TAGS: [],
                ALLOWED_ATTR: [],
              }).trim()}
            {element.digital_asset_id?.value &&
              ` [${element.digital_asset_id?.value}]`}
          </span>
        </div>
      </div>
    </>
  );
};

export default DigitalAssetImage;
